import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";
import { consolePrimaryColor } from "@Console/styles/consoleGlobalColors";

export const GroupOverviewContainer = styled.div`
  max-width: 56.25rem;
  width: 100%;
  height: max-content;
  margin: 5rem auto 0 auto;
  padding: 1rem;

  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (max-width: 768px) {
    margin-top: 1rem;
  }

  .top-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    flex-wrap: wrap;

    @media (max-width: 768px) {
      button {
        width: 100%;
      }
    }
  }

  .loader {
    width: fit-content;
    margin: 0 auto;
  }
`;

export const GoToGroupButton = styled(ConsolePageButtonStyles)`
  background-color: ${consolePrimaryColor};
  color: white;
  padding: 0;

  a {
    padding: 0.5rem 1rem;
  }
`;
